export default (data) => Boolean(data.NodeId && data.DocumentObjectId);
